export const css = {
	root: '_3BanmVeT',
	grouphead: '_1McnCwWC',
	actions: '_2EmbEbEP',
	group: '_3McWN2Ev',
	progress: '_1adYtpLW',
	toc: '_3MYSR0Zq',
	resource: '_1QSD_SYg',
	competencyConnection: '_1qiMIzy_',
	topicBlock: '_39aV3W1X',
	titleBlock: '_3vzO8cf0',
	title: '_1zTb0Jf_',
	close: '_AdfiTTa',
	deck: '_1-GV4qjo',
	refTitleBlock: '_5Zz_Svez',
	complete: '_2tEPelDC',
	incomplete: '_3pfDw6z-',
	refTitle: '_3vXG9FlH',
	fragment: 'w_t_bTer',
	readButton: '_1QNDFKTj',
	legend: '_8IN7_nvH',
	legendText: '_3cbEo-II',
	action: 'wzmvhT9o',
	actionIcon: 'Oi5fLEFk',
	actionText: '_2-rw2dOX',
	activitycontent: '_1V1JPV_s',
	videolink: '_3g2LyJub',
	cialink: '_2yAMwqVX',
	ciacontent: 'eJEBMngU',
	resourcecontent: '_1qv_xGAB',
	resourcelink: '_2IOCcfjD',
	scorePill: '_2mO1HXUU',
	' _key': 'certwise-theme/certwise/book-widgets/topicgroup'
};

export default css;
